export default __webpack_public_path__ + "static/home-banner2-9af1a25a72cb9b53c7e9bc634dc2e40f.jpg";